/**
 * PHFCTA
 *
 * Full-width call-to-action section with a navy background, centered text,
 * and an external link button. Used at the bottom of PHF landing pages.
 *
 * Props:
 * - title (string, required): Large heading in orange
 * - body (string, required): Supporting paragraph in white
 * - highlight (string, optional): Bold emphasis line rendered between body and button
 * - buttonText (string, required): Label for the CTA button
 * - buttonUrl (string, required): External URL the button links to
 */
const PHFCTA = ({ title, body, highlight, buttonText, buttonUrl }) => {
  return (
    <div className="bg-blue-navy py-20 px-4">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="!text-[42px] font-bold text-orange font-poppins mb-6 leading-tight">
          {title}
        </h2>
        <p className="text-white text-[18px] mb-4 leading-relaxed">
          {body}
        </p>
        {highlight && (
          <p className="text-white font-bold text-[18px] mb-8">{highlight}</p>
        )}
        <a
          href={buttonUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-orange hover:bg-orange-dark1 text-white font-semibold text-[16px] py-4 px-12 rounded-full transition-colors"
        >
          {buttonText}
        </a>
      </div>
    </div>
  );
};

export default PHFCTA;
